// Este es el punto de entrada principal para todo el JavaScript de tu sitio.
// Vite tomará este archivo y creará una versión optimizada y única para producción.

// Importamos los módulos en un orden lógico.
import CanvasManager from './canvas-manager.js';

// --- CONFIGURACIÓN INICIAL Y CORRECCIONES ---
import './chromium-scroll-fix.js';       // Corrección de scroll para navegadores Chromium.
import './performance-optimizer.js';     // Optimizaciones de rendimiento.
import './theme-toggle.js';              // Lógica para cambiar entre tema claro/oscuro.

// --- NAVEGACIÓN Y TURBO ---
import './turbo.umd.js';                 // Librería Turbo para navegación tipo SPA.
import './turbo-config.js';              // Configuración personalizada para Turbo.
import './turbo-manager.js';             // Gestión de eventos y ciclos de vida de Turbo.

// --- EFECTOS VISUALES Y ANIMACIONES DEL HEADER ---
import './navbar-scroll.js';             // Efecto de la barra de navegación al hacer scroll.
import './parallax-effect.js';           // Efecto parallax en imágenes o fondos.

// --- LÓGICA DE COMPONENTES Y SECCIONES ---
import './mobile-menu.js';               // Funcionalidad del menú hamburguesa en móviles.
import './intersection-observer.js';     // Lógica central para animaciones al hacer scroll.
import './typewriter-effect.js';         // Animación de máquina de escribir.
import './honeycomb-connections.js';     // Animaciones para la sección de hexágonos.
import './preparacion-animations.js';    // Animaciones específicas para la sección "Preparación".
import './mission-animations.js';        // Animaciones específicas para la sección "Misión y UAS".
import './global-animations.js';         // Animaciones globales (scroll reveal).
import './gsap-animations.js';           // Reveal del hero + scroll-scrubbing del hexágono (GSAP).
import './roadmap-animations.js';        // Dron recorriendo el roadmap de academia (GSAP).

// Variable para mantener referencia a la instancia y limpiarla si es necesario
let canvasManagerInstance = null;

const initCanvasManager = () => {
    // Pequeño delay para asegurar que Turbo ha insertado el DOM y los estilos se han aplicado
    setTimeout(() => {
        const canvas = document.getElementById('starfield-canvas');
        if (canvas) {
            // Si hay una instancia previa (aunque sea de otro canvas que ya no está), podemos intentar limpiarla
            // pero lo más importante es crear la nueva.
            // CanvasManager no tiene un método estático de cleanup, pero al crear uno nuevo
            // se encarga de buscar el elemento 'starfield-canvas' actual.

            console.log('Inicializando Starfield Canvas...', canvas);
            canvasManagerInstance = new CanvasManager();

            // Forzar opacidad por si acaso la transición falla
            canvas.style.opacity = '1';
        }
    }, 100); // 100ms de cortesía
};

// Inicialización para carga inicial y navegación Turbo
document.addEventListener('DOMContentLoaded', initCanvasManager);
document.addEventListener('turbo:load', initCanvasManager);
document.addEventListener('turbo:frame-render', initCanvasManager);
document.addEventListener('turbo:render', initCanvasManager); // Añadido por seguridad

console.log('Todos los módulos han sido cargados a través de main.js.');

// Scroll to top when navigating via main-content frame (e.g., Footer links)
document.addEventListener('turbo:frame-render', (event) => {
    if (event.target.id === 'main-content') {
        window.scrollTo(0, 0);
    }
});

// Enable View Transitions API for smooth frame updates AND full page navigation
const handleViewTransition = (event) => {
    // Check if the browser supports View Transitions
    if (document.startViewTransition) {
        // Prevent imediate render
        event.preventDefault();

        document.startViewTransition(() => {
            // Resume the Turbo render inside the transition
            event.detail.resume();
        });
    }
};

document.addEventListener('turbo:before-frame-render', handleViewTransition);
document.addEventListener('turbo:before-render', handleViewTransition);

